import {
	getVerificationSessions,
	GetVerificationSessionsParams,
	GetVerificationSessionsResponse,
} from "@/api/identity-verification";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";
import { useQuery } from "@tanstack/react-query";
import { identityVerificationKeys } from "./keys";

export default function useGetIdentityVerificationSessions(
	params: GetVerificationSessionsParams,
	options?: QueryOptionsWithoutKeyAndFn<GetVerificationSessionsResponse>,
) {
	return useQuery({
		queryFn: () => getVerificationSessions(params),
		queryKey: identityVerificationKeys.sessions(params),
		refetchOnWindowFocus: false,
		...options,
	});
}
